export default {
    Petition: {
        My : "của cá nhân",
        Unit : "của đơn vị",
        SheetName : "Danh sách kiến nghị {title}",
        AllPetitionCreatorName : "Họ và tên",
        PersonalPetitionCreatorName : "Họ và tên",
        OrgPetitionCreatorName : "Họ và tên",
        AllPetitionCreatorJobTitleName : "Chức vụ",
        AllPetitionCreatorOrgUnitName : "Phòng ban",
        AllPetitionCreatorOrgName : "Đơn vị",
        AllPetitionProcessContent : "Nội dung kiến nghị",
        AllPetitionProcessField : "Lĩnh vực kiến nghị",
        OrgReply : "Phụ trách/Đơn vị trả lời",
        ContentReply : "Nội dung trả lời",
        Deadline : "Hạn trả lời",
        RejectedReason: "Lý do trả lại",
        UserReject: "Phụ trách trả lại",
        Email : "Email",
        Phone : "Số điện thoại",
        AllPetition : "Danh sách kiến nghị {title}",
        PetitionByStatus : "Danh sách kiến nghị {title}",
        GroupCaption : "Người gửi kiến nghị",
        TitleAllPetition : "Tổng hợp kiến nghị {title}",
        SubTitle : "Tháng {month}"
    }
}